import { useRouteModal } from '../../route-modals/hooks/useRouteModal'
import { EModalType } from '../../route-modals/types/modalTypes'
import { EventDialogTab } from './useEventDialogTabs'

export type UseLiveEventModalHookParams = {
  eventId?: string
  eventTypeId: string
  trackedGameId: string
  durationStart?: number
  durationEnd?: number
  tab?: EventDialogTab
  screenshotIndex?: number
}

export const useLiveEventModal = () => {
  const { pushModal } = useRouteModal()
  const showLiveEventModal = ({
    trackedGameId,
    eventTypeId,
    eventId,
    durationStart,
    durationEnd,
    tab = EventDialogTab.AllEvents,
    screenshotIndex,
  }: UseLiveEventModalHookParams) => {
    pushModal({
      type: EModalType.LIVE_EVENT,
      params: {
        trackedGameId,
        liveEventTypeId: eventTypeId,
        liveEventId: eventId,
        durationStart: durationStart?.toString(),
        durationEnd: durationEnd?.toString(),
        tab,
        screenshotIndex: screenshotIndex?.toString(),
      },
    })
  }

  return {
    showModal: showLiveEventModal,
  }
}
